<script>
const template = require('@/helpers/Settings').default.theme + '/' + __filename.replace(/^.*[\\\/]/, '').replace(/\?.*$/, '')

const requireTheme = require.context('./themes/', true)

export default {
    name: 'oc-form-feedback',
    mixins: [
        requireTheme('./' + template).default
    ],
    inject: [
        'form'
    ],
    props: {
        name: {
            type: String,
            required: true
        },
        model: {
            type: Object
        },
        useTooltips: {
            type: Boolean,
            default: false
        },
        displayErrors: {
            type: Boolean,
            default: true
        },
        displayFirstErrorOnly: {
            type: Boolean,
            default: false
        },
        displayWarnings: {
            type: Boolean,
            default: true
        },
        validFeedback: {
            type: [String, Number],
            default: null
        },
        invalidFeedback: {
            type: [String, Number],
            default: null
        },
        errorAttrs: {
            type: Object,
            default: () => ({})
        },
        warningAttrs: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        $_form() {
            return this.model || this.form
        },
        visible() {
            return this.$_displayErrors || this.$_displayWarnings || this.hasValidFeedback || this.hasInvalidFeedback
        },
        $_displayErrors() {
            return this.displayErrors && this.hasErrors
        },
        $_displayWarnings() {
            return this.displayWarnings && this.hasWarnings
        },
        hasValidFeedback() {
            return ! this.hasErrors &&
                    this.isTouched &&
                    (
                        this.validFeedback !== null ||
                        this.$slots['valid-feedback'] !== undefined ||
                        this.$scopedSlots['valid-feedback'] !== undefined
                    )
        },
        hasInvalidFeedback() {
            return this.invalidFeedback !== null
        },
        isTouched() {
            return this.$_form.getValidator().isFieldDirty(this.name)
        },
        errors() {
            return this.$_form.getValidator().errors(false).get(this.feedbackKey)
        },
        firstError() {
            return this.$_form.getValidator().errors(false).first(this.feedbackKey)
        },
        hasErrors() {
            return this.$_form.getValidator().errors(false).has(this.feedbackKey)
        },
        hasWarnings() {
            return this.$_form.getValidator().warnings(false).has(this.feedbackKey)
        },
        warnings() {
            return this.$_form.getValidator().warnings(false).get(this.feedbackKey)
        },

        feedbackKey() {
            return this.$_form.getValidator().getUniqueFieldKey(this.name)
        },

        errorClasses() {
            return this.errorAttrs.class === undefined ? {} : this.errorAttrs.class
        },
        warningClasses() {
            return this.warningAttrs.class === undefined ? {} : this.warningAttrs.class
        }
    }
}
</script>
